import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import "react-data-table-component-extensions/dist/index.css";
import Header from "../layouts/CustomerHeader";
import Sidebar from "../layouts/CustomerSidebar";
import axios from "../api/axios";
import {  Apitoken, Authtoken } from "../Global";
import {MaterialReactTable} from 'material-react-table';
import PropTypes from "prop-types";

const CustomerLoading = () => {
  const [menu, setMenu] = useState(false);
  const [data, setData] = useState([]);

  let customer_id = localStorage.getItem("customer_id");
  let season_id = localStorage.getItem("season_id");
  const formData =({
    customer: customer_id,
    season_id: season_id,
  });
  useEffect(() => {
    axios
      .post(
        "/customerportal/supply-chain-loading/listings",
        formData,
        {
          headers: { Authorization: `${Authtoken}`, Apitoken: Apitoken },
        }
      )
      .then((response) => {
        setData(response.data.data.supply_chain_loading);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);


  const toggleMobileMenu = () => {
    setMenu(!menu);
  };


// ✅ Custom Cell Component with PropTypes
const OrderLinkCell = ({ row }) => {
  return (
    <a href={`/customerportal/loadings-view/${row.original.id}`} className="">
      {row.original.order ? row.original.order.po_number : ""}
    </a>
  );
};

OrderLinkCell.propTypes = {
  row: PropTypes.shape({
    original: PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      order: PropTypes.shape({
        po_number: PropTypes.string,
      }),
    }),
  }).isRequired,
};

  const columns = [
  
        {
      header: "Order",
      accessorFn: (row) => `${row.id}`,
      Cell: OrderLinkCell,
    },
   
    {
      header: 'Location',
      accessorFn: (row) => (row.location ? row.location.title : ''),
    },
    {
      header: 'Transit Supplier',
      accessorFn: (row) => (row.transitsupplier ? row.transitsupplier.name : ''),
    },
  
    {
      accessorKey: 'sous_dum',
      header: 'Sous Dum',
    },
    {
      header: 'Loading Status',
      accessorFn: (row) => (row.location_status ? row.location_status.title : ''),
    },
  
  ];




  return (
    <>
      <div className={`main-wrapper customer-portal-main  ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />

        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row align-items-center">
                <div className="col">
                  <h3 className="page-title">Supply Chain Loadings</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/customerportal/profile">Dashboard</Link>
                    </li>
                    <li className="breadcrumb-item active">
                    Supply Chain Loading
                    </li>
                  </ul>
                </div>
              
              </div>
            </div>

            <div className="row">
              <div className="col-sm-12">
                <div className="card card-table">
                  <div className="card-body">
                    <div className="table-responsive">
                    <MaterialReactTable columns={columns} data={data} 
                      enableColumnOrdering
                      enablePinning
                      
                    />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default CustomerLoading;
